import axios from 'axios';

const API_KEY = '19396225-c483f75d28f30d4068a3a7270'; 
const BASE_URL = 'https://pixabay.com/api/';

/**
 * Виконує HTTP-запит до Pixabay API для отримання зображень.
 * @param {string} query - Пошукове слово.
 * @param {number} page - Номер сторінки.
 * @returns {Promise<Object>} - Проміс, що повертає властивість data з відповіді Axios.
 */
export async function getImagesByQuery(query, page) {
    const params = {
        key: API_KEY,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
        page: page,        // Номер сторінки
        per_page: 15,      // 15 об'єктів на сторінці
    };

    try {
        const response = await axios.get(BASE_URL, { params });
        return response.data; 
    } catch (error) {
        console.error("Error fetching images from Pixabay:", error);
        throw new Error("Failed to fetch images."); 
    }
}